import portugueseContent from './pt.json';
import englishContent from './en.json';

const textContent = {
  ...portugueseContent,
  ...englishContent,
};

export default textContent;
